import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
  CircularProgress,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import { useMsal } from "@azure/msal-react";
import { useState } from "react";
import { loginRequest } from "../../config/authConfig";
import { Helmet } from "react-helmet-async";
import { APP_TITLE } from "../../constant";
import { MicrosoftIcon } from "../../components/SvgIcons/SvgIcons";

const Login = () => {
  const { instance } = useMsal();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // const handleMicrosoftSignIn = async () => {
  //   setLoading(true);
  //   setError(null);

  //   try {
  //     await instance.loginPopup(loginRequest);
  //   } catch (error) {

  //     let errorMessage = "Login failed. Please try again.";

  //     if (error.errorCode === "user_cancelled") {
  //       errorMessage = "Login was cancelled.";
  //     } else if (error.errorCode === "popup_window_error") {
  //       errorMessage = "Popup was blocked. Please allow popups for this site.";
  //     } else if (error.message) {
  //       errorMessage = `Login failed: ${error.message}`;
  //     }

  //     setError(errorMessage);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // src/pages/Auth/Login.jsx
const handleMicrosoftSignIn = async () => {
  setLoading(true);
  setError(null);

  try {
    await instance.loginRedirect(loginRequest);
    // No code after this line will run because the page navigates away
  } catch (error) {
    let errorMessage = "Login failed. Please try again.";

    if (error.errorCode === "user_cancelled") {
      errorMessage = "Login was cancelled.";
    } else if (error.message) {
      errorMessage = `Login failed: ${error.message}`;
    }

    setError(errorMessage);
    setLoading(false);
  }
};

  return (
    <>
      <Helmet>
        <title>Log In | {APP_TITLE}</title>
        <meta
          name="description"
          content="Sign in to IGNA Scout using your Microsoft 365 work account."
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "background.default",
          py: 4,
        }}
      >
        <Container maxWidth="sm">
          <Card
            elevation={2}
            sx={{
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <CardContent sx={{ p: 4 }}>
              <Stack spacing={3} alignItems="center">
                <Box
                  sx={{
                    width: 64,
                    height: 64,
                    bgcolor: "primary.main",
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <DescriptionIcon sx={{ fontSize: 32, color: "white" }} />
                </Box>

                <Typography
                  variant="h5"
                  component="h1"
                  sx={{
                    fontWeight: 600,
                    color: "text.primary",
                  }}
                >
                  IGNA Scout
                </Typography>

                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ textAlign: "center" }}
                >
                  AI-Assisted Interview Platform
                </Typography>

                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 500,
                    color: "text.primary",
                    mt: 2,
                  }}
                >
                  Sign in with your work account
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "center", mb: 1 }}
                >
                  Use your Microsoft 365 credentials to access the platform
                </Typography>

                <Button
                  variant="outlined"
                  fullWidth
                  size="large"
                  onClick={handleMicrosoftSignIn}
                  disabled={loading}
                  startIcon={
                    loading ? <CircularProgress size={20} /> : <MicrosoftIcon />
                  }
                  sx={{
                    py: 1.5,
                    borderColor: "rgba(0, 0, 0, 0.23)",
                    color: "text.primary",
                    "&:hover": {
                      borderColor: "rgba(0, 0, 0, 0.4)",
                      bgcolor: "rgba(0, 0, 0, 0.04)",
                    },
                    "&:disabled": {
                      borderColor: "rgba(0, 0, 0, 0.12)",
                    },
                  }}
                >
                  {loading ? "Signing in..." : "Sign in with Microsoft 365"}
                </Button>

                {error && (
                  <Alert severity="error" sx={{ width: "100%" }}>
                    {error}
                  </Alert>
                )}

                <Alert
                  severity="info"
                  sx={{
                    width: "100%",
                    mt: 2,
                    "& .MuiAlert-icon": {
                      alignItems: "center",
                    },
                  }}
                >
                  <AlertTitle sx={{ fontWeight: 600 }}>
                    Invite-only access
                  </AlertTitle>
                  Only authorized TA team members can access this platform.
                  Contact your administrator for access.
                </Alert>
              </Stack>
            </CardContent>
          </Card>

          {/* <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              display: "block",
              textAlign: "center",
              mt: 3,
            }}
          >
            Integrated with Zoho Recruit
          </Typography> */}
        </Container>
      </Box>
    </>
  );
};

export default Login;
